export default function() {
    console.log("B2B update");
    document.querySelectorAll("ul > li.nav-item > a").forEach(function(elem) {
        if (elem.innerText === "B2B Meetings") {
            elem.removeAttribute("href");
        }
    });
}


// WEBPACK FOOTER //
// ./src/js/partials/b2b-link.js